import { Button } from '@verlo/shared/components/ui/button';
import { OptionChips } from '@verlo/shared/components/ui/segmented';
import { Label } from '@verlo/shared/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@verlo/shared/components/ui/dialog';
import { Clock } from 'lucide-react';

const ExtendTimeDialog = ({
  open,
  onOpenChange,
  timeInfo,
  additionalTime,
  onAdditionalTimeChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="confirm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Clock size={20} />
            More time
          </DialogTitle>
          <DialogDescription>
            Current allocation: {timeInfo?.expectedDuration || 90} minutes
            {timeInfo && (
              <span className={timeInfo.isOvertime ? ' text-signal-stop' : ''}>
                {' '}({timeInfo.text})
              </span>
            )}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Add time (minutes)</Label>
            <OptionChips
              value={additionalTime}
              onChange={onAdditionalTimeChange}
              options={[15, 30, 45, 60].map((mins) => ({ value: mins, label: `+${mins}`, testId: `add-${mins}-mins` }))}
            />
          </div>
          
          {/* Over its time, more time counts from now: 30 more is 30 to go (Oct 2026). */}
          <div className="bg-surface-2 rounded-lg p-3 text-sm text-ink-soft" data-testid="add-time-preview">
            {timeInfo?.isOvertime
              ? <><strong>{additionalTime} more minutes from now</strong></>
              : <>New allocation will be: <strong>{(timeInfo?.expectedDuration || 90) + additionalTime} minutes</strong></>}
          </div>
        </div>
        
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button 
            className="bg-verlo"
            onClick={onConfirm}
            data-testid="confirm-add-time-btn"
          >
            Add {additionalTime} minutes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExtendTimeDialog;
